import { createGlobalStyle } from 'styled-components';
import { palette } from 'styled-tools';

const Normalize = createGlobalStyle`
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        -moz-appearance: textfield;
        margin: 0;
    }

    input:disabled,
    textarea:disabled,
    select:disabled {
        background-color: ${palette('gray_opacity_100')};
        border: 1px solid ${palette('gray_opacity_200')};
        color: ${palette('gray_opacity_800')};
    }

    * {
        box-sizing: border-box;
    }
`;

export default Normalize;
